// 应用初始状态
const state = {
  newsOnline: {
    companyDynamic: [],// 卡尔动态
    companyDynamicImg: [],// 卡尔动态图
    dynamicTotal: 0, // 卡尔动态总条数
    mediaReport: [], // 行业新闻
    mediaReportImg: [],// 行业新闻图
    reportTotal: 0, // 行业新闻总条数
  },
  socialBenefit: [] // 社会公益
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js